import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { AuthFooter } from "@/components/app/AuthFooter";
import { ResendVerification } from "@/components/app/ResendVerification";

export default function VerifyEmail() {
  const [sp] = useSearchParams();
  const [state, setState] = useState({ s: "loading", msg: "" });
  const done = useRef(false);
  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const token = sp.get("token");
    if (!token) { setState({ s: "error", msg: "Link verifikasi tidak valid." }); return; }
    api.post("/auth/verify-email", { token })
      .then((r) => setState({ s: "ok", msg: r.data.message }))
      .catch((e) => setState({ s: "error", msg: formatApiError(e) }));
  }, [sp]);
  const Icon = state.s === "ok" ? CheckCircle2 : state.s === "error" ? XCircle : Loader2;
  return (
    <div className="min-h-screen bg-slate-50 flex flex-col">
      <div className="flex-1 flex items-center justify-center p-6">
        <div className="bg-white rounded-2xl border border-slate-200 p-8 max-w-md w-full text-center" data-testid="verify-email-card">
          <Icon size={44} className={`mx-auto mb-4 ${state.s === "ok" ? "text-emerald-600" : state.s === "error" ? "text-rose-600" : "text-slate-400 animate-spin"}`}/>
          <h1 className="text-xl font-semibold text-slate-900">{state.s === "ok" ? "Email Terverifikasi" : state.s === "error" ? "Verifikasi Gagal" : "Memverifikasi..."}</h1>
          <p className="text-sm text-slate-500 mt-2" data-testid="verify-email-message">{state.msg}</p>
          {state.s === "error" && <ResendVerification editable className="mt-5 text-left"/>}
          <Link to="/login" className="inline-block mt-6 text-sm font-medium text-[color:var(--brand)] hover:underline" data-testid="verify-to-login">Ke halaman Masuk</Link>
        </div>
      </div>
      <AuthFooter/>
    </div>
  );
}
